import { RootState } from "../../app/state";
import { licenceAdapter } from "./licenceState";
import { createSelector } from "@reduxjs/toolkit";

const selectRoot = (state: RootState) => state;

export const selectLicenceSlice = (state: RootState) => state.licenceSlice;

export const allLicenceAdapterSelectors = licenceAdapter.getSelectors(selectLicenceSlice);

export const selectAllLicenceList = allLicenceAdapterSelectors.selectAll;

export const selectCurrentLicenceId = createSelector(
  selectLicenceSlice,
  (state) => state.selectedLicenceId
);

export const selectCurrentLicence = createSelector(
  selectRoot,
  selectCurrentLicenceId,
  (root, currentLicenceId) => currentLicenceId ? allLicenceAdapterSelectors.selectById(root, currentLicenceId) : null
);